<template>
  <div id="change-password" class="rounded-item shadow-md">
    <vx-card>
      <div class="setting-card-hidden">
        <div class="setting-card-scroll">
          <div class="vx-row mx-0 mb-6">
            <div class="vx-col pl-0 sm:w-1/4 w-full flex align-center">
              <span>Old Password</span>
            </div>
            <div class="vx-col pr-0 sm:w-3/4 w-full position-relative">
              <vs-input type="password" id="oldPass" class="w-full" icon-pack="feather" icon="icon-lock" icon-no-border v-model="old_password" />
              <div v-if="old_password != ''" style="position: absolute; top: 12px; right: 13px;">
                <div v-if="showOld == false">
                  <eye-icon size="1.25x" class="custom-class text-grey-custom" @click="showOldPassword"></eye-icon>
                </div>
                <div v-else>
                  <eye-off-icon size="1.25x" class="custom-class text-grey-custom" @click="showOldPassword"></eye-off-icon>
                </div>
              </div>
            </div>
          </div>
          <div class="vx-row mx-0 mb-6">
            <div class="vx-col pl-0 sm:w-1/4 w-full flex align-center">
              <span>New Password</span>
            </div>
            <div class="vx-col pr-0 sm:w-3/4 w-full position-relative">
              <vs-input type="password" id="newPass" class="w-full" icon-pack="feather" icon="icon-lock" icon-no-border v-model="new_password"
                name="new_password"
                v-validate="{regex: '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$'}" 
                :danger="errors.has('new_password')"
                danger-text="New password shall has at least 8 characters, 1 lowercase character, 1 UPPERCASE character and 1 special character!"
              />
              <div v-if="new_password != ''" style="position: absolute; top: 12px; right: 13px;">
                <div v-if="showNew == false">
                  <eye-icon size="1.25x" class="custom-class text-grey-custom" @click="showNewPassword"></eye-icon>
                </div>
                <div v-else>
                  <eye-off-icon size="1.25x" class="custom-class text-grey-custom" @click="showNewPassword"></eye-off-icon>
                </div>
              </div>
            </div>
          </div>
          <div class="vx-row mx-0 mb-6">
            <div class="vx-col pl-0 sm:w-1/4 w-full flex align-center">
              <span>Confirm Password</span>
            </div>
            <div class="vx-col pr-0 sm:w-3/4 w-full position-relative">
              <vs-input type="password" id="confirmPass" class="w-full" icon-pack="feather" icon="icon-lock" icon-no-border v-model="confirm_password" />
              <div v-if="confirm_password != ''" style="position: absolute; top: 12px; right: 13px;">
                <div v-if="showConfirm == false">
                  <eye-icon size="1.25x" class="custom-class text-grey-custom" @click="showConfirmPassword"></eye-icon>
                </div>
                <div v-else>
                  <eye-off-icon size="1.25x" class="custom-class text-grey-custom" @click="showConfirmPassword"></eye-off-icon>
                </div>
              </div>
            </div>
          </div>
          <div class="vx-row mx-0">
            <div class="vx-col pr-0 sm:w-3/4 w-full ml-auto">
              <vs-button class="mr-3 mb-2" @click="changePassword" style="min-width: 140px;">Submit</vs-button>
            </div>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import { EyeIcon } from 'vue-feather-icons'
import { EyeOffIcon } from 'vue-feather-icons'
export default {
  name: 'vs-change-password',
  components:{
    EyeIcon,
    EyeOffIcon
  },
  data(){
    return {
      old_password: '',
      new_password: '',
      confirm_password: '',
      showOld: false,
      showNew: false,
      showConfirm : false,
      isOpenLoading: false
    }
  },
  methods:{
    showOldPassword(){
      var x = document.getElementById("oldPass");
      if (x.type === "password") {
        this.showOld = true;
        x.type = "text";
      } else {
        this.showOld = false;
        x.type = "password";
      }
    },
     showNewPassword(){
      var y = document.getElementById("newPass");
      if (y.type === "password") {
        this.showNew = true;
        y.type = "text";
      } else {
        this.showNew = false;
        y.type = "password";
      }
    },
     showConfirmPassword(){
      var z = document.getElementById("confirmPass");
      if (z.type === "password") {
        this.showConfirm = true;
        z.type = "text";
      } else {
        this.showConfirm = false;
        z.type = "password";
      }
    },
    openLoadingInDiv(){
      this.$vs.loading({
        container: '#change-password',
        scale: 0.8
      })
      this.isOpenLoading = true;
      setTimeout( ()=> {
        if(this.isOpenLoading) {
          this.closeLoading();
          // this.$vs.notify({
          //   title:'Notification',
          //   text: 'Change password failed',
          //   color:'danger',
          //   position:'top-right'})
          this.$vs.dialog({
            color: 'danger',
            title: 'Notification',
            text: 'Change password failed',
            acceptText: 'OK'
          })
        }
      }, 10000);
    },
    closeLoading() {
      this.$vs.loading.close('#change-password > .con-vs-loading');
      this.isOpenLoading = false;
    },
    changePassword(){
      if(!this.errors.has('new_password')) {
        if(!this.isOpenLoading) {
          this.openLoadingInDiv();
        }
        const obj = {
          old_password: this.old_password,
          new_password: this.new_password,
          repeat_password: this.confirm_password
        }
        this.$store.dispatch("appSetting/CHANGE_PASSWORD" ,obj).then(() => {
          this.old_password = '';
          this.new_password = '';
          this.confirm_password = '';
          this.closeLoading();
          this.$vs.notify({
            title:'Success',
            text:'Change password success!',
            color:'success',
            position:'top-right'
          })
        }).catch((err) => {
          this.closeLoading();
          if(err.old_password){
            this.$vs.notify({
              title:'Fail',
              text: err.old_password[0],
              color:'danger',
              position:'top-right'
            })
          }else if(err.new_password){
            this.$vs.notify({
              title:'Fail',
              text: err.new_password[0],
              color:'danger',
              position:'top-right'
            })
          } else {
             this.$vs.notify({
              title:'Fail',
              text: err.repeat_password[0],
              color:'danger',
              position:'top-right'
            })
          }
        })
      }
    }
  }
}
</script>